export const ONLINETI_STATUS = {
  INITIAL: 'initial',
  INCOMPLETE_PURCHASE: 'incomplete_purchase',
  ON_HOLD: 'on_hold',
  DRAFT: 'draft',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  DISCREPANCY: 'discrepancy',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  FRAUD: 'fraud',
  UNKNOWN: 'unknown',
} as const;

export const ONLINETI_STORED_STATUSES = [
  ONLINETI_STATUS.INCOMPLETE_PURCHASE,
  ONLINETI_STATUS.DRAFT,
  ONLINETI_STATUS.ON_HOLD,
  ONLINETI_STATUS.CONFIRMED,
  ONLINETI_STATUS.CANCELED,
  ONLINETI_STATUS.COMPLETED,
  ONLINETI_STATUS.FRAUD,
];

export const DEFAULT_ONLINETI_TRADEIN_NAME = 'Trade-in';

export const ONLINETI_SELF_SERVICE_BASE_URL =
  process.env.NEXT_PUBLIC_SELF_SERVICE_BASE_URL ?? '';
export const ONLINETI_SELF_SERVICE_URL = `${ONLINETI_SELF_SERVICE_BASE_URL}/status`;

export const ONLINETI_WIDGET_BASE_URL =
  process.env.NEXT_PUBLIC_WIDGET_BASE_URL ?? '';
export const ONLINETI_WIDGET_API_URL = `${ONLINETI_WIDGET_BASE_URL}/api`;

export const ONLINETI_SUPPORT_URL = `${ONLINETI_SELF_SERVICE_BASE_URL}/support`;
